export default {
  en: {
    common: {
      loading: "Loading...",
      unit: "Yen",
      salesPeriod: "Sales Period",
      validBetween: "Valid between",
      attention: "Please note",
      other: "Other",
      officialWebsite: "official website",
      terms: "Terms of service",
      aboutRefund: "About refunds",
      agreeToTerms: "I agree to the terms of service",
      contact: "Contact us",
      seller: "Seller",
      ticketName: "Ticket Name",
      ticketingInfoLabel: "Ticket information",
      startDateLabel: "Start date",
      useButtonLabel: "Use",
      cancelButtonLabel: "Back",
      backButtonLabel: "Back",
      priceLabel: "Price",
      passengers: "Number of tickets",
      validPeriod: "Valid period",
      effectiveDays: "days",
      Tickets: "Tickets",
      number: "Number",
      notUsed: "Not used",
      notIssued: "Not issued",
      currentTime: "Current time",
      fromStation: "Departure station",
      feature: "",
      mai: " tickets",
      availableplace: "Supported facilities / shops / areas",
      IntroductionOfMenu: "ご提供メニューの紹介",
      externalLink: "External Link",
      makesureNote: "Please be sure to check. Notes about this ticket",
      storesAndFacilities: "Stores / Facilities",
      kintetsuExpressURL:
        "https://www.ticket.kintetsu.co.jp/vs/en/T/TZZ/TZZ10.do?op=tDisplayVisitorMenu",
      accountDialog: {
        header: "Account information needs to be set",
        body: "Please sign in to your account and set your credit card information.",
        button: "Go to account",
      },
      cardRegistrationDialog: {
        header: "Failed to verify your credit card",
        body: "Please check your credit card information and try again.",
        button: "Go to account",
      },
      serverErroDialog: {
        header: "An error is occuring",
        body: "Sorry, the booking system is currently unavailable",
        button: "Back",
      },
    },
    Errors: {
      cardAuthFailed: {
        header: "Settlement failure",
        title: "Credit card authentication failed",
        description: "Please check your credit card information and try again",
        buttonLabel: "Back to ticket details",
      },
      unauthorizedAccount: {
        header: "Unauthorized account",
        title: "Account information needs to be set",
        description:
          "Please sign in to your account and set your credit card information.",
        buttonLabel: "Go to account",
      },
      invalidPageAccess: {
        title: "Invalid Page Access",
        description:
          "Please sign in to your account and set your credit card information.",
        buttonLabel: "Go to Ticket Store",
      },
      reachedPurchaseLimit: {
        title: "Unable to purchase",
        description: "You have reached the limit for this ticket.",
        buttonLabel: "Back",
      },
    },
    BookingMobility: {
      mobilityInfo: "Mobility information",
      company: "Company",
      price: "Price",
      pleaseNote: "Please note",
      other: "Other",
      officialSite: "Official site",
      terms: "Terms of service",
      contact: "Contact us",
      agreeToTerms: "I agree to the terms of service",
      goToBooking: "Continue to purchase",
      goToBookingDetail: "Confirm booking",
      checkingLogin: "Now checking login information...",
    },
    BookingForm: {
      headLabel: "Transportation",
      leadMessage: "Please select departure and destination",
      leadNotes: "You can also select from the map",
      departureLabel: "Departure",
      departureLabelPlaceholder: "Please select your departure location",
      arrivalLabel: "Arrival",
      arrivalLabelPlaceholder: "Please select your arrival location",
      bookingInfoLabel: "Booking information",
      dateLabel: "Desired date",
      datetimeFor: {
        label: "Departure / Arrival",
        depatureOption: "Departure",
        arrivalOption: "Arrival",
      },
      datetimeError: "You can specify a date within 7 days from today",
      datetimeErrorForDfp:
        "You can specify a date between today and %{date} (the nearest expiration date of your digital free pass)",
      adultSeatCountLabel: "Adults",
      childSeatCountLabel: "Childs",
      seatCountNotes: "Adults (Age 12~), Child (6 ~ 12 years old)",
      seatCountError: "Up to %{max} seats are available.",
      conditions: {
        label: "Boarding conditions",
        shareableOption: "Carpooling priority",
        reservedOption: "Reserved",
      },
      payBy: {
        label: "Payment",
        creditOption: "Credit card",
        cashOption: "Pay at station",
        dfpOption: "Digital free pass",
      },
      representativeInfoLabel: "Main traveler",
      familyNameLabel: "Last name",
      familyNamePlaceholder: "Last name",
      firstNameLabel: "First name",
      firstNamePlaceholder: "First name",
      phoneLabel: "Phone",
      phonePlaceholder: "Please enter number without hyphens",
      submitButtonLabel: "Continue",
      cancelButtonLabel: "Back",
      creatingDemand: "Contacting tentative booking...",
      createDemandErrorDialog: {
        overlap: {
          header: "Too short interval from previous booking",
          body: "Please change the time and try again.",
        },
        estimation: {
          header: "Could not find any available mobilities",
          body: "Please change the date or number of passengers.",
        },
        area: {
          header: "Some unavailable areas are included",
          body: "Please try another departure or destination.",
        },
        other: {
          header: "An error occurred",
          body: "Please try after a while.",
        },
        cancel: "Modify",
      },
    },
    BookingConfirmation: {
      headLabel: "Confirm booking",
      leadMessage: "Please confirm your booking details",
      leadNotes: "* Please confirm your booking within 2 minutes",
      demandInfoHeaderLabel: "Booking information",
      mobilityLabel: "Transportation",
      priceLabel: "Price",
      price: "￥ %{price}",
      dfpPrice: "digital free pass",
      payByLabel: "Payment",
      datetimeLabel: "Date",
      travelTimeLabel: "Ride time",
      dateTimeForDepature: "Depature",
      travelTimeValue: "About %{min} min.",
      seatCountsLabel: "Passengers",
      seatCountsValue: "Adults:&nbsp;%{adult}&emsp;Childs:&nbsp%{child}",
      pickUpPositionLabel: "Departure",
      dropOffPositionLabel: "Destination",
      conditionsLabel: "Boarding conditions",
      representativeInfoHeaderLabel: "Main traveler",
      representativeName: "Name",
      phoneLabel: "Phone",
      approveButtonLabel: "Confirm booking",
      cancelButtonLabel: "Edit",
      decliningDemand: "Now canceling tentative booking...",
      payBy: {
        credit: "Credit card",
        cash: "Pay at station or paper ticket",
        dfp: "Digital free pass",
      },
      datetimeFor: {
        departure: "Departure",
        arrival: "Destination",
      },
      conditions: {
        shareable: "Carpooling priority",
        reserved: "Reserved",
      },
    },
    BookingArrangement: {
      demandCanceledDialog: {
        header: "Booking failed",
        body: "Booking process could not be completed because of timeout.",
        button: "Retry booking",
      },
      demandUpdatedDialog: {
        header: "Update successfully finished",
      },
      decliningDialog: {
        header: "Now canceling tentative booking...",
      },
      loadingMessage: {
        payment: "Please wait for payment process...",
        approveDemand: "Now booking a mobility...",
        updateSeatCounts: "Now updating booking...",
        loading: "Loading...",
      },
    },
    BookingDetail: {
      countDownCard: {
        datetime: "Date",
        label: "Until pickup",
        status: {
          pickingUp: "Coming",
          boarding: "Riding",
          finished: "Done",
          canceled: "Canceled",
        },
      },
      demandInfoHeaderLabel: "Booking information",
      mobilityLabel: "Transportation",
      orderId: "Booking number",
      priceLabel: "Price",
      price: "￥ %{price}",
      dfpPrice: "digital free pass",
      sharedPrice: " shared",
      payByLabel: "Payment",
      datetimeLabel: "Date",
      travelTimeLabel: "Ride time",
      travelTimeValue: "About %{min} min.",
      seatCountsLabel: "Passengers",
      seatCountsValue: "Adults:&nbsp;%{adult}&emsp;Childs:&nbsp%{child}",
      pickUpPositionLabel: "Departure",
      dropOffPositionLabel: "Arrival",
      conditionsLabel: "Riding conditions",
      representativeInfoHeaderLabel: "Main traveler",
      representativeName: "Name",
      phoneLabel: "Phone",
      attention: "Please note",
      updateButton: {
        active: "Change passengers",
        used: "Used",
        canceled: "Canceled",
      },
      cancelButton: {
        active: "Cancel booking",
        used: "Used",
        canceled: "Canceled",
      },
      payBy: {
        credit: "Credit card",
        cash: "Pay at station or paper ticket",
        dfp: "Digital free pass",
      },
      datetimeFor: {
        departure: "Departure",
        arrival: "Destination",
      },
      conditions: {
        shareable: "Carpooking priority",
        reserved: "Reserved",
      },
      landmarkImageDialog: {
        button: "Close",
      },
      cancelDemandConfirmDialog: {
        header: "Cancel your booking?",
        body: "If you have already paid, you will get a full refund.",
        submitButton: "Cancel",
        cancelButton: "Back",
      },
      cancelingDemandDialog: {
        header: "Now canceling booking....",
      },
      cancelDemandDoneDialog: {
        header: "Booking canceled",
      },
    },
    BookingUpdate: {
      headerTitle: "Change passengers",
      headLabel: "Transportation",
      bookingInfoLabel: "Booking information",
      adultSeatCountLabel: "Adults",
      childSeatCountLabel: "Childs",
      seatCountNotes: "Adults (Age 12~), Child (6 ~ 12 years old)",
      seatCountError: "Up to %{max} seats are available.",
      submitButtonLabel: "Continue",
      cancelButtonLabel: "Back",
      checkingUpdateDemandDialog: {
        header: "Now checking booking status...",
      },
      updateDemandErrorDialog: {
        header: "All seats are taken",
        button: "Back to ticket details",
      },
    },
    BookingUpdateConfirmation: {
      headerTitle: "Confirm booking",
      leadMessage: "Please confirm your booking details",
      leadNotes: "* Please confirm your booking within 10 minutes.",
      demandInfoHeaderLabel: "Booking information",
      mobilityLabel: "Transportation",
      priceLabel: "Price after changed ",
      price: "￥ %{price}",
      dfpPrice: "digital free pass",
      priceDiffLabel: "Difference",
      payByLabel: "Payment",
      datetimeLabel: "Date",
      departure: "Departure",
      travelTimeLabel: "Ride time",
      travelTimeValue: "About %{min} min.",
      seatCountsLabel: "Passengers",
      seatCountsValue: "Adults:&nbsp;%{adult}&emsp;Childs:&nbsp%{child}",
      pickUpPositionLabel: "Departure",
      dropOffPositionLabel: "Destination",
      conditionsLabel: "Boarding conditions",
      approveButtonLabel: "Confirm booking",
      cancelButtonLabel: "Edit",
      payBy: {
        credit: "Credit card",
        cash: "Pay at station or paper ticket",
        dfp: "Digital free pass",
      },
      datetimeFor: {
        departure: "Departure",
        arrival: "Destination",
      },
      conditions: {
        shareable: "Carpooking priority",
        reserved: "Reserved",
      },
    },
    BookingPaymentError: {
      errorDialog: {
        header: "An error occurred",
        body: "Payment processing was cancelled. Please book again.",
        button: {
          approve: "Back",
          update: "Back",
        },
      },
      decliningDialog: {
        header: "Now canceling tentative booking...",
      },
    },
    // Ticketing
    TicketStoreTicketing: {
      // MasterBook
      ticketsIncluded: "Tickets Included",
      buyRapidTrain: "Buy Kintetsu Limited Express tickets",
      // BookBooking
      bookingHeader: "Enter payment information",
      goToBooking: "Continue to purchase",
      goToBookingConfirm: "Continue",
      defaultStation: "Please select your boarding station",
      boardingStation: "Boarding station (optional)",
      cantSelectOutOfTerm: "※ You can't select out of use period.",
      bookBookingDescription:
        "Enter the information required for purchase and press 'Continue to purchase'.",
      dateHelp: "You can select up to one month in the future",
      // BookBookingConfirmation
      bookBookingConfirmationTitle: "Confirm payment",
      confirmAttention: "Please confirm payment details.",
      confirmAttentionSub:
        "* Please complete the payment procedure within 10 minutes.",
      payByLabel: "Continue to payment",
      modifyLabel: "Edit",
      cautionOfSelectStationOdakyu:
        "※The freepass will be valid from your boarding station to Odawara Station.",
      cautionOfSelectStationTanzawa:
        "※The freepass will be valid from your boarding station to Tanzawa Station.",
      cautionOfPayment_12:
        "Please note that there will be NO refund even in cases when services are suspended due to bad weather etc.\nWould you like to proceed?",
      cautionOfPayment_34:
        "購入した時点でサブスクリプションの１日目となります。開始日の変更や払いもどしはできません。\nサブスクリプションの解約は期間最終日の前々日までにお願いします。これを過ぎると期間が更新され、同時に課金も発生します。\n購入しますか？",
      // BookBookingResultダイアログ
      BookBookingResult: {
        header: "Purchase Result",
        title:
          "Ride comfortably with the purchase of Kintetsu Limited Express tickets!",
        description: "Move around in comfort while sitting in a reserved seat.",
        buttonLabel1: "Buy Kintetsu Limited Express tickets",
        buttonLabel2: "Go to My tickets",
      },
    },
    MyTicketTicketing: {
      // Book
      refund: "Refund",
      refunded: "Refunded",
      // BookRefund
      bookRefundTitle: "Refund",
      bookRefundDescription: "Please confirm ticket information and price",
      refundLabal: "Refund",
      refundAmount: "Refund amount",
      serviceCharge: "Service charge",
      total: "Total",
      refundComplete: "Refund complete",
      // Pass/Sheet
      attention: "Please show this screen to the staff",
      validUntil: "Valid until",
      made: "",
      ticketDetails: "Ticket details",
      storesAndFacilities: "Stores / Facilities",
      entryThePasscode: "Entry the passcode",
      UseTicket: "Use ticket",
      UseStamp: "Use stamp",
      QRReader: "Use ticket",
      inputPasscode: "Enter the passcode",
      checkoutPoint: "Check place",
      checkoutDate: "Check date",
      validBooks: {
        title: "You will not be able to refund.",
        description1:
          "There will be no refunds once you start using the ticket '",
        description2: "'. Do you want to start?",
        buttonLabel1: "Start using",
        buttonLabel2: "Cancel",
      },
      validFreePass: {
        title: "Use a ticket",
        description:
          "This ticket has no expiration date. Please enjoy it to the fullest.",
      },
      validPeriodPass: {
        title1: "Please use within",
        title2: "minutes",
        description1: "Ticket becomes invalid after ",
        description2:
          " minutes of use. Choose Cancel if you don't want to start yet.",
        buttonLabel1: "Use",
        buttonLabel2: "Cancel",
      },
      QRSuccess: {
        title: "Code verified",
        description: "Please show the ticket details screen to the staff.",
      },
      QRFailed: {
        title: "Verification failed",
        description:
          "Check the ticket contents and try reading the 2D barcode again, or show the passcode entry screen to the staff.",
        buttonLabel1: "Passcode entry screen",
        buttonLabel2: "Cancel",
      },
      passCodeFailed: {
        title: "Verification failed",
        description: "Please check the ticket information and try again.",
      },
      couponCodeFailed: {
        title: "Verification failed",
        description: "Please try again.",
      },
      StampRally: {
        title: "Stampbook",
        confirm: "Confirm",
        stamp: "Stamp",
        use: "Use",
        open: "Open",
      },
    },
    Coupon: {
      couponCode: "Coupon code",
      copy: "Copy",
      useCoupon: "Use this coupon",
      pastCoupon: "Past coupons",
      copiedCoupon: "Coupon code copied",
      helpText:
        "*If you have an 8-digit or 16-digit coupon code, please go to the coupon code input from the menu button and enter the code.",
    },
  },
};
